import Vue from "vue";
import axios from "axios";

//import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
//const controller = self.customSetting.staffChangeController;
const getStaffChange = self.customSetting.getStaffChange;
const postStaffChange = self.customSetting.postStaffChange;
export default {
  //查詢 承攬商入廠施工群組
  getAllCourseList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getStaffChange}/GeAllCoureList`)
        .then((res) => {
          //context.commit("GET_ALL_COURSE_LIST", res);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  //查詢 廠商施工負責人/安衛人員
  getAllPersonListForDuty: (context, courseId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getStaffChange}/GetAllPersonListForDuty?Course_Id=${courseId}`
        )
        .then((res) => {
          //context.commit("GET_ALL_PERSON_LIST_FOR_DUTY", res);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  //查詢 列出符合條件且尚未入廠核銷的單據列表
  getDailyProjectList: (context, { courseId, applyPk }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getStaffChange}/GetDailyProjectList?Course_Id=${courseId}&Apply_PK=${applyPk}`
        )
        .then((res) => {
          //context.commit("GET_DAILY_PROJECT_LIST", res);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  //變更 安衛與監工人員  (變更負責人員)
  chgDutyPerson: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postStaffChange}/ChgDutyPerson`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
};
